import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import {
  AplicadosBox,
  BtnFiltrarWrapper,
  FiltroBox,
  FiltroEtiqueta,
  FlechaContainer,
  ItemBox,
  Line,
} from "./localStyle";
import CheckBoxGroupFilter from "_+_Portal/components/Genericos/CheckBoxGroupFilter/CheckBoxGroupFilter";
import CruzEtiqueta from "_+_Portal/assets/images/generico/CruzEtiqueta";
import { hideModal, showModal } from "_+_Portal/context/Actions/modal/modal";
import IconBlack from "_+_Portal/assets/images/generico/IconBack";
import "./FiltrosTD.css";

const FiltrosTD = ({
  handleChangeDatePicker,
  handleChangeCentros,
  handleChangeDia,
  handleChangeRango,
  handleChangeEspecialista,
  filtrosData,
  fecha,
  filtros,
  filtrosAplicados,
  setFiltrosAplicados,
  checkboxData,
  setCheckboxData,
  onChangeEtiquetas,
  especialistasOriginal,
  setEspecialistasOriginal,
}) => {
  const { turnosDisponiblesState, modalDispatch } = useContext(PortalContext);
  const [flgFiltros, setFlgFiltros] = useState(null);
  const [showItem, setShowItem] = useState({
    centro: checkboxData?.centros.some((item) => item.checked),
    fecha: true,
    dia: checkboxData?.diasKin.some((item) => item.checked),
    horario: checkboxData?.rangoHorario.some((item) => item.checked),
    especialista: checkboxData?.especialistas.some((item) => item.checked),
  });

  const handleChangeCheckbox = (categoria, updatedData) => {
    setCheckboxData((prev) => ({ ...prev, [categoria]: updatedData }));
    const filtrosSeleccionados = updatedData.filter((item) => item.checked);
    setFiltrosAplicados((prev) => [
      ...prev.filter(
        (f) => !updatedData.some((u) => u.descripcion === f.descripcion)
      ),
      ...filtrosSeleccionados,
    ]);
    if (categoria === "diasKin") {
      handleChangeDia(updatedData);
    } else if (categoria === "rangoHorario") {
      handleChangeRango(updatedData);
    } else if (categoria === "centros") {
      handleChangeCentros(updatedData);
    } else if (categoria === "especialistas") {
      handleChangeEspecialista(updatedData);
      setEspecialistasOriginal(updatedData);
    }
  };

  const etiquetaFecha = (item) => {
    let arrx = [...filtrosAplicados];
    arrx = arrx.filter((etiqueta) => etiqueta.fecha !== true);
    let itemFecha = {
      id: 1,
      descripcion: item,
      fecha: true,
    };
    arrx.push(itemFecha);
    // Actualiza el estado con las etiquetas modificadas
    setFiltrosAplicados(arrx);
  };

  const isEstudios =
    turnosDisponiblesState?.turnosDisponibles?.turnosData?.volverOrigen ===
    "ESTUDIOS";

  const modalEspecialistas = () => {
    showModal(
      "Turnos/ModalEspecialistas/ModalEspecialistas",
      {
        titulo: isEstudios ? "Estudios" : "Especialistas",
        data: especialistasOriginal,
        handleChangeCheckbox: handleChangeCheckbox,
        setEspecialistasOriginal: setEspecialistasOriginal,
        dissmiss: dissmiss,
        categoria: "especialistas",
        placeholderBusqueda: isEstudios
          ? "Buscar estudio..."
          : "Buscar especialista...",
        labelBusqueda: isEstudios ? "Estudio" : "Especialista",
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const onChangeItemShow = (e, item) => {
    setShowItem({
      ...showItem,
      [e]: !item,
    });
  };

  useEffect(() => {
    setCheckboxData({
      centros:
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
          "LABORATORIO"
          ? filtrosData?.centrosLabo.filter(
            (item) => item.descripcion !== "Todos los centros"
          ) || []
          : filtrosData?.centros.filter(
            (item) => item.descripcion !== "Todos los centros"
          ) || [],
      diasKin:
        filtrosData?.diasKin.filter((item) => item.descripcion !== "Todos") ||
        [],
      rangoHorario:
        filtrosData?.rangoHorario.filter(
          (item) => item.descripcion !== "Todos"
        ) || [],
      especialistas:
        filtrosData?.especialistas.filter(
          (item) => item.descripcion !== "Todos"
        ) || [],
    });
    setEspecialistasOriginal(
      filtrosData?.especialistas.filter(
        (item) => item.descripcion !== "Todos"
      ) || []
    );
    setFlgFiltros(false);
  }, [filtros]);

  const noventaDiasDespues = new Date(fecha);
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);
  const diaSelecionado =
    turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada;

  return (
    <React.Fragment>
      {!flgFiltros && (
        <>
          <p className="rb24t">Filtros</p>
          <AplicadosBox>
            {filtrosAplicados?.length > 0 ? (
              filtrosAplicados.map((item, index) => {
                return (
                  <FiltroEtiqueta
                    className="rb14l c-white"
                    key={"FiltrosTDEtiqueta" + index}
                  >
                    {item.descripcion}
                    <div
                      className="cruzBox pointer"
                      onClick={() => onChangeEtiquetas(item)}
                    >
                      <CruzEtiqueta color={"var(--color-white)"} />
                    </div>
                  </FiltroEtiqueta>
                );
              })
            ) : (
              <p className="rb14l txtFiltros">No hay filtros aplicados</p>
            )}
          </AplicadosBox>
          <Line></Line>
          <FiltroBox>
            <ItemBox className="pointer" onClick={() => onChangeItemShow("fecha", showItem.fecha)}>
              <p className="rb18m">Fecha</p>
            </ItemBox>
            <div className={`content ${showItem.fecha ? "visible" : "filtro-hidden"}`}>
              <DatePicker
                fechaInicial={`${fecha.getFullYear()} ${fecha.getMonth() + 1
                  } ${fecha.getDate()}`}
                selectedFecha={`${!diaSelecionado ? "" : diaSelecionado}`}
                fechaFinal={`${noventaDiasDespues.getFullYear()} ${noventaDiasDespues.getMonth() + 1
                  } ${noventaDiasDespues.getDate()}`}
                onChange={(e) => {
                  handleChangeDatePicker(e);
                  etiquetaFecha(e);
                }}
                customCss={"datePickerStyle"}
                customDateCss={"calendarStyle"}
              />
            </div>
          </FiltroBox>
          <Line></Line>
          <FiltroBox>
            <ItemBox className="pointer" onClick={() => onChangeItemShow("centro", showItem.centro)}>
              <p className="rb18m">Centros</p>
              <FlechaContainer
                $rotate={showItem.centro ? 1 : 0}
              >
                <IconBlack color={"var(--color-white)"} size={8} />
              </FlechaContainer>
            </ItemBox>
            <div
              className={`content ${showItem.centro ? "visible" : "filtro-hidden"}`}
            >
              <CheckBoxGroupFilter
                data={checkboxData?.centros}
                onChange={(data) => handleChangeCheckbox("centros", data)}
              />
            </div>
          </FiltroBox>
          <Line></Line>
          <FiltroBox>
            <ItemBox className="pointer" onClick={() => onChangeItemShow("dia", showItem.dia)}>
              <p className="rb18m">Días</p>
              <FlechaContainer
                $rotate={showItem.dia ? 1 : 0}
              >
                <IconBlack color={"var(--color-white)"} size={8} />
              </FlechaContainer>
            </ItemBox>
            <div className={`content ${showItem.dia ? "visible" : "filtro-hidden"}`}>
              <CheckBoxGroupFilter
                data={checkboxData?.diasKin}
                onChange={(data) => handleChangeCheckbox("diasKin", data)}
              />
            </div>
          </FiltroBox>
          <Line></Line>
          <FiltroBox>
            <ItemBox className="pointer" onClick={() => onChangeItemShow("horario", showItem.horario)}>
              <p className="rb18m">Horarios</p>
              <FlechaContainer
                $rotate={showItem.horario ? 1 : 0}
              >
                <IconBlack color={"var(--color-white)"} size={8} />
              </FlechaContainer>
            </ItemBox>
            <div
              className={`content ${showItem.horario ? "visible" : "filtro-hidden"}`}
            >
              <CheckBoxGroupFilter
                data={checkboxData?.rangoHorario}
                onChange={(data) => handleChangeCheckbox("rangoHorario", data)}
              />
            </div>
          </FiltroBox>
          <Line></Line>
          <FiltroBox>
            <ItemBox className="pointer" onClick={() => onChangeItemShow("especialista", showItem.especialista)}>
              <p className="rb18m">
                {turnosDisponiblesState?.turnosDisponibles?.turnosData
                  ?.volverOrigen === "ESTUDIOS"
                  ? "Estudios"
                  : "Especialistas"}
              </p>
              <FlechaContainer
                $rotate={showItem.especialista ? 1 : 0}
              >
                <IconBlack color={"var(--color-white)"} size={8} />
              </FlechaContainer>
            </ItemBox>
            <div
              className={`content ${showItem.especialista ? "visible" : "filtro-hidden"}`}
            >
              <CheckBoxGroupFilter
                data={checkboxData?.especialistas.slice(0, 5)}
                originalData={especialistasOriginal}
                onChange={(data) => handleChangeCheckbox("especialistas", data)}
              />
              {checkboxData?.especialistas?.length > 5 && (
                <BtnFiltrarWrapper>
                  <button
                    type="button"
                    className="btn-filtrar rb18m"
                    onClick={() => modalEspecialistas()}
                  >
                    Filtrar
                  </button>
                </BtnFiltrarWrapper>
              )}
            </div>
          </FiltroBox>
        </>
      )}
    </React.Fragment>
  );
};

export default FiltrosTD;
